/**
 * PermissionGuard - 권한 기반 라우트 가드
 *
 * @description
 * 메뉴 권한(MenuPermissionsDto) 또는 PermissionAction(actions.unconditional/conditional)
 * 기반으로 접근을 제어합니다. 권한이 없는 경우 접근 거부 메시지를 표시합니다.
 *
 * - menus 권한 root + sub-permission(예: 'goals.company') 모두 지원
 * - HRup 은 actions(hrup.*) 기반
 */

import type { ReactNode } from 'react';
import { useOptionalUser } from '@/app/providers/UserContext';
import { DefaultError } from '../ErrorScreen';
import { checkPermission, type PermissionType } from './permissionCheck';

export type { PermissionType };

interface PermissionGuardProps {
  permission: PermissionType;
  children: ReactNode;
  deniedMessage?: string;
}

export const PermissionGuard = ({
  permission,
  children,
  deniedMessage = '해당 페이지에 접근 권한이 없습니다.',
}: PermissionGuardProps) => {
  const userCtx = useOptionalUser();
  const permissions = userCtx?.permissions;

  // 사용자 정보 미로드: SsoTokenProvider 가 인증을 책임지므로 children 렌더링
  if (!permissions?.menus) {
    return <>{children}</>;
  }

  if (!checkPermission(permission, permissions)) {
    return <DefaultError message={deniedMessage} />;
  }

  return <>{children}</>;
};
